import React from "react"
import styled, { css } from "styled-components"
import colors from "@constants/colors"
import { timings, cubicBezier } from "@constants/animation"
import { body } from "@constants/typography"
import { ColorCheckmark } from "@components/icons"

const Container = styled.button`
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-start;
  display: flex;
  outline: none;
  width: 100%;
  height: 36px;
  padding: 0;
  border: none;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }

  &:focus,
  &:active {
    outline: none;
  }
`

const Box = styled.div<{ checked: boolean }>`
  ${({ checked }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    margin-right: 12px;
    border-radius: 2px;
    background-color: ${checked ? colors.obsidian : colors.divider};

    svg {
      transition: opacity ${timings.quick} ${cubicBezier};
      opacity: ${checked ? 1 : 0};
    }
  `}
`

const Label = styled.div`
  ${body}
  display: flex;
  align-items: center;
  color: ${colors.slateDark};
`

export interface MenuItemCheckboxProps {
  label: string
  checked: boolean
  onClick: () => void
}

const MenuItemCheckbox: React.FC<MenuItemCheckboxProps> = ({
  label,
  checked,
  onClick,
}) => {
  return (
    <Container onClick={onClick}>
      <Box checked={checked}>
        <ColorCheckmark />
      </Box>
      <Label>{label}</Label>
    </Container>
  )
}

export default MenuItemCheckbox
